import { render, staticRenderFns } from "./StatusButton.vue?vue&type=template&id=8ff07708&"
import script from "./StatusButton.vue?vue&type=script&lang=js&"
export * from "./StatusButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports